const TYPES = {
  STORE_SCROLL_LOCATION: 'utils/STORE_SCROLL_LOCATION',
  SET_REBRAND: 'utils/SET_REBRAND',
  SET_ORG_ASSOCIATION: 'utils/SET_ORG_ASSOCIATION',
};

const storeScrollCoordinates = options => async (dispatch) => {
  const { xCoordinate, yCoordinate } = options;
  dispatch({
    type: TYPES.STORE_SCROLL_LOCATION,
    payload: { x: xCoordinate, y: yCoordinate },
  });
};

const setRebrand = isRebrand => async (dispatch) => {
  dispatch({
    type: TYPES.SET_REBRAND,
    payload: isRebrand,
  });
};

const setOrgAssociation = orgAssociation => ({
  type: TYPES.SET_ORG_ASSOCIATION,
  payload: orgAssociation,
});

export {
  storeScrollCoordinates,
  setRebrand,
  setOrgAssociation,
};

export default {
  TYPES,
  storeScrollCoordinates,
  setRebrand,
  setOrgAssociation,
};
